import { FC } from "react";
import LeaderboardTableRows from "@/features/challenge/components/leaderboard/LeaderboardTableRows";
import { Box, Flex } from "@radix-ui/themes";
import { globalLeaderboard } from "../../models/leaderboardProps";
import DateObject from "react-date-object";

/**
 * Component for displaying the global leaderboard table.
 *
 * @component
 * @param {globalLeaderboard} props - The properties for the GlobalLeaderboardTable component.
 * @param {number} lastUpdateTimestamp - The timestamp of the last update.
 * @param {Array} leaderboard - The array of leaderboard items.
 * @returns {JSX.Element} The rendered GlobalLeaderboardTable component.
 */

const GlobalLeaderboardTable: FC<globalLeaderboard> = ({
  lastUpdateTimestamp,
  leaderboard,
  refetch,
}): JSX.Element => {
  const refreshTime = new DateObject(lastUpdateTimestamp).add(15, "minutes");

  return (
    <Box>
      {/* <GlobalLeaderboardHeader
        lastUpdateTimestamp={lastUpdateTimestamp}
        refreshTime={refreshTime}
        refetch={refetch}
      /> */}
      <Flex direction="column" gap="3">
        {leaderboard?.map((item: any, index: number) => {
          const userName = item?.userInfo?.userName;
          const fullName = item?.userInfo?.fullName;
          const name = [userName, fullName];
          const avatar = item?.userInfo?.profileLogoUrl;
          const slug = item?.userInfo?.slug;
          const points = item?.totalScore;

          return (
            <LeaderboardTableRows
              key={index}
              rank={index + 1}
              logo={avatar}
              name={
                userName
                  ? name
                  : ["Something went wrong", "Couldn't load user details"]
              }
              points={points}
              slug={slug}
              game="leaderboard"
              pointsType={null}
            />
          );
        })}
      </Flex>
    </Box>
  );
};

export default GlobalLeaderboardTable;
